import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export const ContactCTA = () => {
  return <section className="bg-gray-900 py-16" data-id="element-403">
      <div className="container mx-auto px-6" data-id="element-404">
        <div className="max-w-3xl mx-auto text-center" data-id="element-405">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-406">
            Klaar om uw droomveranda te realiseren?
          </h2>
          <p className="text-lg text-white/80 mb-8" data-id="element-407">
            Neem vandaag nog contact met ons op voor een vrijblijvend
            adviesgesprek of vraag direct een offerte aan.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-408">
            <Link to="/adviesgesprek" className="px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white rounded-md transition-colors flex items-center justify-center" data-id="element-409">
              <span data-id="element-410">Plan een adviesgesprek</span>
            </Link>
            <Link to="/offerte-aanvragen" className="px-8 py-3.5 bg-[#CDA735] hover:bg-[#B89429] text-white rounded-md transition-colors flex items-center justify-center shadow-lg hover:shadow-[0_0_20px_rgba(205,167,53,0.3)]" data-id="element-411">
              <span data-id="element-412">Offerte aanvragen</span>
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-413" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
};